<div class="content" id="carrierApproval">
  <div class="container-fluid Confirmation-invoice" >
      <div class="content">
      <div class="confirmation-block">
          <div class="col-md-12 p-0 mt-3">
            <ngx-loading [show]="gridload"></ngx-loading>
           <div class="row">
             <div style="margin-bottom:10px; margin-left:10px">
               <h3>
                 <span style="padding-right:5px"></span>
                 <i class="fa fa-info-circle"></i>
                 <b>Carrier Account Correspondence</b>
               </h3>
             </div>
           </div>

           <table class="table-1" id="pdfTable-1" style="width:100%">
              <tr>
                <td>Account Number : <b><span class="">{{approvalRes.AccountNumber}}</span></b><br/></td>
                <td>Account Name : <b><span class="">{{approvalRes.Name}}</span></b><br/></td>                  
                <td>Trading Name : <b><span class="">{{approvalRes.TradingName}}</span></b><br/></td>
                
                  
              </tr>
              <tr>
                <td>Carrier Type : <b><span class="">{{approvalRes.CarrierType}}</span></b><br/></td>
                <td>Status : <b><span class="">{{changeStatus}}</span></b><br/></td>
                <td>Date Submitted :<b><span class="">{{approvalRes.DateSubmitted | date: 'dd/MM/yyy'}}</span></b><br/> </td>                 
                  
               
              </tr>

              <tr>
                <!-- only to be enabled with the "Status change" selection -->
                <td *ngIf="this.utility.btnAction!=1" colspan=3>
                  Change Carrier Account Status to:
                  <span>
                    <select style="width:300px"  [(ngModel)]="approvalRes.statusId" id="statusCarrier" (change)="statusUpdate()"  class="form-control select-auto">

                      <option value="" disabled selected>Select Status</option>

                      <ng-container *ngIf="approvalRes.status_id<statusId">
                       <option *ngFor="let c of statuses" [ngValue]="c.id">{{c.desc}}</option>
                      </ng-container>

                      <ng-container *ngIf="approvalRes.status_id>=statusId">
                       <ng-container *ngFor="let c of statuses">
                         <option *ngIf="c.id>statusId" [ngValue]="c.id">{{c.desc}}</option>
                       </ng-container>
                      </ng-container>

                    </select>
                  </span>
                  <br/>
                </td>
                <td></td>
              </tr>

              <tr>
                <td colspan="4">
                 <div class="crpdnce-left" style="color:black"><b>Send correspondence to:</b></div>
                 <div class="crpdnce-right">

                  <span class="pl-0"><input type="checkbox" (click)="selectUser(this.emailContacts.LeadUser)" checked name="carrierLead" id ="carrierLead" class="right-check" value=""/>Lead User<br/></span>
                  <span class="pl-0" *ngIf="this.emailContacts.MainContact!=null"><input type="checkbox" [disabled]="this.emailContacts.MainContact==null" (click)="selectUser(this.emailContacts.MainContact)" name="carrierMain" id="carrierMain" class="right-check" value=""/>Main Contact<br/></span>
                  <span class="pl-0" *ngIf="this.emailContacts.Owner!=null"><input type="checkbox" [disabled]="this.emailContacts.Owner==null"  (click)="selectUser(this.emailContacts.Owner)" name="carrierOwner" id="carrierOwner" class="right-check"   value=""/>Owner<br/></span>

                    <!-- <span class="pl-0"><input type="checkbox" (click)="selectUser(emailContacts.LeadUser)" name="permitLead" class="right-check" value=""/>Lead User<br/></span>
                    <span class="pl-0"><input type="checkbox" (click)="selectUser(emailContacts.MainContact)" name="permitMain" class="right-check" value="" [disabled]="emailContacts.MainContact==null"/>Main Contact<br/></span>
                    <span class="pl-0"><input type="checkbox" (click)="selectUser(emailContacts.Owner)" name="permitOwner" class="right-check" value="" [disabled]="emailContacts.Owner==null"/>Owner<br/></span> -->
                    <!-- <div class="form-group">
                      <div class="radio">
                        <input type="radio" (click)="selectUser(this.emailContacts.LeadUser)" name="toContact" class="right-check" checked value=""/>Lead User<br/>
                      </div>
                      <div class="radio">
                        <input type="radio" (click)="selectUser(this.emailContacts.MainContact)" name="toContact" class="right-check" value="" [disabled]="this.emailContacts.MainContact==null || this.emailContacts.MainContact==''"/>Main Contact<br/>
                      </div>
                      <div class="radio">
                        <input type="radio" (click)="selectUser(this.emailContacts.Owner)" name="toContact" class="right-check" value="" [disabled]="this.emailContacts.Owner==null || this.emailContacts.Owner==''"/>Owner<br/>
                      </div>
                    </div> -->
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan=4>
                  <!-- <span class="head-text" style="color:black">Recipients :</span> <span class="pl-0">{{approvalRes.Email}}</span><br/> -->
                  <!-- <b class="cl-wdt">Email Address:&nbsp;&nbsp;</b><span class="pl-0">{{this.crspdType}}</span> -->
                  <span class="head-text" style="color:black">Recipients :</span> <span class="pl-0">{{this.crspdType}}</span><br/>
                  <br/>
                  <ckeditor [(ngModel)]="description" (input)="changes()" debounce="100"></ckeditor>
                </td>
              </tr>

           </table>

           <div class="col-md-12">
                <!-- <button (click)="onSaveAndSend()" title="Save and Send" [disabled]="crspdType==''" name="save" type="submit" id="btnSave"  class="btn btn-md m-clr pull-right hd-btn" style="width:180px; margin-right:0px;margin-bottom:5px; float:right;">Save & Send</button>
                     <button (click)="redirectList()" title="Cancel"  name="cancel" type="submit" id="btnSave"  class="btn btn-danger m-clr pull-right hd-btn mr-2" style="width:180px; margin-right:0px;margin-bottom:5px; float:right;background:#bf2a2a !important;">Cancel</button> -->
              <button name="save" id="btnSave" (click)="onSaveAndSend()" title="Save and Send" type="button" class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2 myButton" [disabled]="crspdType==''" style="width:150px; float:right;">Save & Send</button>
              <button name="cancel" id="btnSave" (click)="redirectList()" title="Cancel" type="button" class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2 myButton" data-dismiss="modal" style="width:150px; float:right;">Close</button>
           </div>

          </div>
        </div>
      </div>

    </div>
  </div>
